/** http 包内使用的公共文案（与 @repo/i18n common 保持一致，仅保留本包引用到的 key） */
export default {
  requestCode: {
    dlsxqcxdl: '登录失效，请重新登录',
  },
  tradeDialog: {
    toastFreezeText: '提交失败！账户已冻结，请联系客服。',
  },
}
